import { createStore } from 'react-sweet-state';
import { cloneDeep } from 'lodash';

import { convertExtractedAnnotations, filterAnnotationsByTool } from 'src/data/annotation';
import { mapToolContentForBriefInput } from 'src/data/brief';
import { getToolMaxWordsPerKeyword } from 'src/data/generationTool';
import { extractBriefAnnotations } from 'src/graphql/annotation';

const INITIAL_STATE = {
  suggestedAnnotations: [],
  loadingSuggestions: false,
  requestedSuggestions: false,
};

export const PRIVATE_ACTIONS = {
  init:
    () =>
    ({ setState }) => {
      setState({
        ...cloneDeep(INITIAL_STATE),
      });
    },
};

export const ACTIONS = {
  fetchSuggestedAnnotations:
    (params) =>
    async ({ setState, dispatch }, { generationTool, customer }) => {
      try {
        if (!generationTool || !params.briefContent) {
          return;
        }
        const brief = mapToolContentForBriefInput(generationTool, params.briefContent);
        const maxWords = getToolMaxWordsPerKeyword(generationTool);

        const result = await extractBriefAnnotations({
          customerId: customer?.id,
          generationTool,
          maxWords,
          brief,
          promptImageId: params.promptImage?.id,
          promptDocumentId: params.promptDocument?.id,
          freestyleToolAllInstructionsData: params.freestyleToolAllInstructionsData,
          urlExtractions: params.urlExtractions,
        });

        const converted = convertExtractedAnnotations(result);
        const filtered = filterAnnotationsByTool(converted, generationTool);
        dispatch(ACTIONS.setSuggestedAnnotations(filtered));
      } finally {
        setState({ loadingSuggestions: false });
      }
    },

  setSuggestedAnnotations:
    (annotations) =>
    ({ setState }) => {
      const sorted = annotations.sort((a, b) => b.score - a.score);
      setState({ suggestedAnnotations: sorted });
    },

  setLoadingSuggestions:
    (loading) =>
    ({ setState }) => {
      setState({ loadingSuggestions: loading });
    },

  clearSuggestedAnnotations:
    () =>
    ({ setState }) => {
      setState({
        suggestedAnnotations: [],
        requestedSuggestions: false,
      });
    },
};

export const AnnotationStore = createStore({
  initialState: INITIAL_STATE,
  actions: ACTIONS,
  name: 'popover-annotations',
});
